import { render, staticRenderFns } from "./addMonitorButton.vue?vue&type=template&id=6bebbe2b&scoped=true"
import script from "./addMonitorButton.vue?vue&type=script&lang=js"
export * from "./addMonitorButton.vue?vue&type=script&lang=js"
import style0 from "./addMonitorButton.vue?vue&type=style&index=0&id=6bebbe2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bebbe2b",
  null
  
)

export default component.exports